/* eslint-disable no-magic-numbers */
/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
import DynamicTable from "@atlaskit/dynamic-table";
import Toggle from "@atlaskit/toggle";
import React, { ReactElement } from "react";
import { MessageContext } from "../../contexts/Message/MessageContext";
import API from "../../services/API";
import { Appointment } from "./Appointment";
import "./Appointments.scss";
import { createUserHead, getUserAppointmentRows } from "./TableCells";

interface Props {
    userId: string;
}

export enum QuerySort {
    asc = "ASC",
    desc = "DESC",
}
interface FiltersState {
    page: number;
    limit: number;
    sort?: QuerySort;
    afterDate?: number | null;
    beforeDate?: number | null;
}
export function UserAppoinemnts({ userId }: Props): ReactElement {
    const messageContext = React.useContext(MessageContext);
    const [isLoading, setIsLoading] = React.useState(true);
    const [appointments, setAppointments] = React.useState<Appointment[]>([]);

    const intialFiltersState: FiltersState = {
        page: 0,
        limit: 1000,
        sort: QuerySort.asc,
        afterDate: Math.round(new Date().getTime() / 1000),
        beforeDate: null,
    };
    const [filter, setFilters] = React.useState(intialFiltersState);

    const toggleHistory = () => {
        if (!filter.beforeDate) {
            setFilters({
                ...intialFiltersState,
                afterDate: null,
                sort: QuerySort.desc,
                beforeDate: Math.round(new Date().getTime() / 1000),
            });
        }
        if (!filter.afterDate) {
            setFilters({
                ...intialFiltersState,
                beforeDate: null,
                afterDate: Math.round(new Date().getTime() / 1000),
            });
        }
    };

    React.useEffect(() => {
        setIsLoading(true);
        API.HandleGetRequest<Appointment[]>(
            `/appointments/user/${userId}?page=${filter.page}&limit=${
                filter.limit
            }&sort=${filter.sort}${
                filter.afterDate ? `&afterDate=${filter.afterDate}` : ""
            }${filter.beforeDate ? `&beforeDate=${filter.beforeDate}` : ""}`
        )
            .then((response) => {
                setAppointments(response);
                setIsLoading(false);
            })
            .catch((err) => {
                setIsLoading(false);
                messageContext.actions.setMessage({
                    title: "Etwas ist schiefgelaufen. Die Termine konnten nicht geladen werden",
                    isOpen: true,
                    titleApparencce: "danger",
                    buttons: [
                        {
                            buttonText: "OK",
                            onClick: () => messageContext.actions.closeModal(),
                        },
                    ],
                });
            });
    }, [filter]);

    return (
        <div className="appointment-wrapper">
            <DynamicTable
                caption={
                    <div className="caption-wrapper">
                        Termine
                        <div className="appointment-load-history">
                            <small>Vergangene Termine anzeigen</small>
                            <Toggle
                                onChange={toggleHistory}
                                size="large"
                                label="Allow pull request"
                            />
                        </div>
                    </div>
                }
                isLoading={isLoading}
                head={createUserHead(Boolean(filter.afterDate))}
                rows={getUserAppointmentRows(
                    appointments,
                    Boolean(filter.afterDate)
                )}
                rowsPerPage={10}
                page={filter.page}
                defaultPage={1}
                isFixedSize
            />
        </div>
    );
}
